import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Box, Container, Grid, Typography } from '@material-ui/core';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import { retrieveContentfulImage } from '../../common/image.js';
import clsx from 'clsx';
import PropTypes__default from 'prop-types';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';
import { BUTTON_TYPES } from '../../common/constant.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    iconTitleTextCtaInnerContainer: {
      maxWidth: "755px",
      padding: theme.spacing(10, 2)
    },
    horizontalAlignCenter: {
      margin: "0 auto"
    },
    mb4: {
      marginBottom: theme.spacing(4)
    },
    mb5: {
      marginBottom: theme.spacing(5)
    },
    icon: {
      width: theme.spacing(8.75),
      height: theme.spacing(8.75)
    },
    maxWidth390: _defineProperty({}, theme.breakpoints.up("sm"), {
      maxWidth: "390px"
    }),
    maxWidth500: _defineProperty({}, theme.breakpoints.up("sm"), {
      maxWidth: "500px"
    }),
    maxWidth600: _defineProperty({}, theme.breakpoints.up("sm"), {
      maxWidth: "600px"
    })
  };
});
var IconTitleTextCTA = function IconTitleTextCTA(_ref) {
  var _BUTTON_TYPES$cta$typ, _BUTTON_TYPES$cta$typ2;
  var bgColor = _ref.bgColor,
    image = _ref.image,
    title = _ref.title,
    description = _ref.description,
    cta = _ref.cta;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  var getTextAlignment = function getTextAlignment() {
    return isExtraSmallScreen() ? "left" : "center";
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(Container, {
    className: classes.iconTitleTextCtaInnerContainer
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: isExtraSmallScreen() ? "flex-start" : "center"
  }, image && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    className: clsx(classes.mb4, classes.horizontalAlignCenter, classes.icon),
    src: retrieveContentfulImage(image.url, {
      width: 70,
      height: 70
    }),
    alt: image.alt
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    component: "h2",
    align: getTextAlignment(),
    className: clsx(classes.mb4, classes.maxWidth390)
  }, title), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    align: getTextAlignment(),
    className: clsx(classes.maxWidth500, classes.mb4)
  }, description), cta && /*#__PURE__*/React__default.createElement(CustomButton, {
    variant: (_BUTTON_TYPES$cta$typ = BUTTON_TYPES[cta.type]) === null || _BUTTON_TYPES$cta$typ === void 0 ? void 0 : _BUTTON_TYPES$cta$typ.variant,
    color: (_BUTTON_TYPES$cta$typ2 = BUTTON_TYPES[cta.type]) === null || _BUTTON_TYPES$cta$typ2 === void 0 ? void 0 : _BUTTON_TYPES$cta$typ2.color,
    className: classes.horizontalAlignCenter,
    href: cta.url,
    size: "large"
  }, cta.label))));
};
IconTitleTextCTA.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  description: PropTypes__default.string,
  image: PropTypes__default.shape({
    url: PropTypes__default.string,
    alt: PropTypes__default.string
  }),
  cta: PropTypes__default.shape({
    label: PropTypes__default.string,
    url: PropTypes__default.string,
    type: PropTypes__default.string
  })
};

export { IconTitleTextCTA as default };
//# sourceMappingURL=IconTitleTextCTA.js.map
